/* =========================================================
   Preguntas sobre el rol que se hacen en varias pantallas.

   Existe porque la respuesta estaba escrita como `role === 'SITE_MGR'`
   en seis sitios, y al aparecer SITE_ADMIN —que también tiene un solo
   site— cada uno de esos seis había que encontrarlo y corregirlo. Con
   un nombre, el próximo rol que se añada se cambia aquí.
   ========================================================= */
import type { Role } from '@/types';

/** ¿El alcance de esta cuenta es un site concreto?
 *
 *  Gerente y admin de site tienen los dos un solo centro; lo que los
 *  separa es si pueden escribir en él, y eso lo responde usePuedeEditar,
 *  no esto. Aquí se decide qué datos se le enseñan. */
export const esDeUnSite = (role: Role) => role === 'SITE_MGR' || role === 'SITE_ADMIN';
